import { AppRoutes } from './routes'
import { SigningProviders } from './providers'

export function App() {
  return (
    <SigningProviders>
      <AppRoutes />
    </SigningProviders>
  )
}
